import { useTranslation } from "react-i18next";
import defaultContent from "../../../../../../content/performanceIncomeDashboard";
import defaultAwardContent from "../../../../../../content/awardLabels";
import "./CurrentEstimatedIncomeCard.scss";

export interface CurrentEstimatedIncomeCardProps {
  value: string;
  annual?: boolean;
}

export const CurrentEstimatedIncomeCard = ({ value, annual = true }: CurrentEstimatedIncomeCardProps) => {
  const { t } = useTranslation(["performanceIncomeDashboard", "awardLabels"]);
  const dc = defaultContent;
  const noDataLabel = t(
    "awardLabels.no-data-available",
    defaultAwardContent.awardLabels["no-data-available"] as string,
  );
  const isNoData = value === "--";
  const label = annual
    ? String(t("income.annualEstimatedIncome", dc.income.annualEstimatedIncome))
    : String(t("income.monthlyEstimatedIncome", dc.income.monthlyEstimatedIncome));

  return (
    <div className="current-estimated-income-card">
      <span className="current-estimated-income-card__label" data-testid="current-estimated-income-label">
        {label}
      </span>
      <span
        className="current-estimated-income-card__value"
        {...(isNoData ? { role: "text", "aria-label": noDataLabel } : {})}
      >
        {isNoData ? <span aria-hidden="true">{value}</span> : value}
      </span>
    </div>
  );
};
